export default "__VITE_ASSET__CM1l014Q__"